export { useSyncExternalStore as default } from "use-sync-external-store/shim"
